import React from 'react';

export default function StatCard({ label, value, sub, primary }) {
  return (
    <div className={`stat${primary ? ' primary' : ''}`}>
      <div className="stat-label">{label}</div>
      <div className="stat-val">{value}</div>
      {sub && <div className="stat-sub">{sub}</div>}
    </div>
  );
}
